import React from "react";
import imgleft from '../../assets/images/asset35.jpeg';
import styles from './Menu.module.css';

export const Menu = () => {
  return (
    <>
      <div className={styles.one}>
        <div className="container MenuC mx-auto px-8 mt-10 mb-10">
          <p className="text-center font-semibold text-2xl py-5">
            List of available plates
          </p>
          <h1 className="text-center text-4xl font-bold">THE MENU</h1>
          <div className="flex justify-center mt-6">
            <DownloadPdf />
          </div>
        </div>

        <div
          style={{
            backgroundImage: `linear-gradient(to bottom, rgba(21,40,59,0.0), rgba(21,40,59,0.0)), url(${imgleft})`,
            backgroundSize: "100% 100%",
            backgroundAttachment: "fixed",
          }}
        >
          <div className={styles.one}>
            <div className="container MenuC mx-auto px-8 mt-10 mb-10">
              <MenuCard />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const MenuData = [
  { heading: "Littichokha", desc: "Our very very own traditional dish from the Bihar and Jharkhand regions of India is now right here.", price: "" },
  { heading: "Badam Milk", desc: "Nutritious and scrumptious beverage crafted from almonds, milk, and sugar.", price: "" },
  { heading: "Burger", desc: "Burgers are a popular fast food item such as a cooked patty of beans, lentils, or vegetables, served in a sliced bread roll referred to as a bun.", price: "" },
  { heading: "Chole Kulche", desc: "Chole, additionally called chana masala, a famous North Indian dish made with chickpeas cooked in a highly spiced and tangy tomato-based sauce is right here.", price: "" },
  { heading: "Cold Coffee", desc: "Refreshing and energizing beverage made with chilled coffee, milk, sugar, and ice cubes. Made particularly for the recent summer time months.", price: "" },
  { heading: "Grill Sandwich", desc: "Cooked the use of a grilling technique, normally on a grill, griddle, or panini press. The sandwich is assembled with various components, including bread, cheese, veggies.", price: "" },
  { heading: "Idli", desc: "Most popular south Indian dish made from a batter of fermented rice and lentils. Steamed to make smooth, fluffy, and spongy cakes. Nutritionally, proteins, dietary fiber.", price: "" },
  { heading: "Lassi", desc: "Popular traditional yogurt-based totally drink from the Indian subcontinent. It is made with the aid of blending yogurt with water and spices, to create a fresh and nutritious beverage.", price: "" },
  { heading: "Makhana Kheer", desc: "A creamy and delicious dessert made with makhana, additionally called fox nuts or lotus seeds. It is a popular dish in North India, in particular throughout festivals and special occasions.", price: "" },
  { heading: "Mommos", desc: "Enjoy the dumplings that originated in Tibet and are famous in many Asian countries, especially in India, Nepal, and Bhutan.", price: "" },
  { heading: "Mutter Kachori", desc: `"Matar Kachori" or "Matar Ki Kachori" is a famous Indian snack made with a spiced green pea filling encased in a crisp, deep-fried pastry.`, price: "" },
  { heading: "Pasta", desc: "Wah! Chaat, a savory snack that originated in India and is famous at some stage in South Asia. Typically consisting of a base of fried dough, along with samosas or tikkis (potato patties).", price: "" },
  { heading: "Poha", desc: "Enjoy the most popular breakfast dish in India crafted from flattened, dehusked rice. It is mild, clean to digest, and a nutritious meal option.", price: "" },
  { heading: "Samosa", desc: "Yummy Indian snack which include a triangular pastry shell filled with a spicy combination, usually containing potatoes, peas, and numerous spices.", price: "" },
  { heading: "Sattu", desc: "Introducing our fresh and nutritious Sattu drink, a conventional Indian beverage, it truly is best for staying cool and energized!", price: "" },
  { heading: "Spring Roll", desc: "Spring rolls, a famous Asian appetizer which includes a filling, frequently made with vegetables, paneer, or cheese rolled inside a thin pastry wrapper after which deep-fried or on occasion served clean.", price: "" },
  { heading: "Vada", desc: "South Indian snack made from a batter of lentils or gram flour, with spices like cumin, curry leaves, and green chilies, and deep-fried until crispy.", price: "" },
  { heading: "Vada Pav", desc: "Wow! Vada pav! Mouth watering popular street meals from the nation of Maharashtra in India. Spicy potato fritter (vada) sandwiched among a pav, which is a small, tender bread roll.", price: "" },
  { heading: "Pav Bhaji", desc: "This most famous street meals dish from Maharashtra, has a spiced combination of mashed vegetables (bhaji) served with buttered bread rolls (pav)", price: "" },
];

export const MenuCard = () => {
  return (
    <div className="grid xl:grid-cols-3 max-sm:grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
      {MenuData.map((MenuItem, index) => (
        <div key={index} className="card hover:border-orange-500">
          <h1 className="font-semibold text-xl mt-8  text-left">{MenuItem.heading}</h1>
          <p className="mt-5">{MenuItem.desc}</p>
          {/* <p className="mt-1 font-bold">₹{MenuItem.price}</p> */}
        </div>
      ))}
    </div>
  );
};

// Download PDF Button
export function DownloadPdf() {
  const handleLabelClick = () => {
    const pdfUrlpath = process.env.PUBLIC_URL + '/tingletastemenu.pdf';
    downloadPdf(pdfUrlpath);
  };

  const downloadPdf = (url) => {
    const path = document.createElement('a');
    path.href = url;
    path.setAttribute('download', 'tingletastemenu.pdf');
    document.body.appendChild(path);
    path.click();
    document.body.removeChild(path);
  };

  return (
    <label className="custom-file-label bg-orange-500 p-2 rounded-md font-semibold text-white hover:bg-gray-500 hover:text-orange-500"
      onClick={handleLabelClick}>
      Click to Download PDF
    </label>
  );
}
